import { useCallback, useEffect, useState } from "react";
import { DeleteTwoTone, EditTwoTone, PlusOutlined } from "@ant-design/icons";
import {
    Button,
    message,
    Row,
    Col,
    Typography,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Form,
    Input,
    Select,
    Switch,
    DatePicker,
    TimePicker,
    Divider,
    Space,
    InputNumber,
} from "antd";
import ListTable from "../../common/ListTable";
import AppContent from "../../common/AppContent";
import AppPageHeader from "../../common/PageHeader";
import ExtraContent from "../Configuration/CommonComponents/ExtraContent";
import FilterComponent from "../Configuration/CommonComponents/FilterComponent";
import { getData, postData, deleteData, putData } from "../../apiServices/common";
import {
    FABRIC_LOADING_CAPACITY_OF_STORES_LIST_ENDPOINT,
    FABRIC_LOADING_CAPACITY_OF_STORES_ADD_ENDPOINT,
    FABRIC_LOADING_CAPACITY_OF_STORES_EDIT_ENDPOINT,
    FABRIC_LOADING_CAPACITY_OF_STORES_DELETE_ENDPOINT,
} from "../../apiServices/API_ENDPOINTS";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import moment from "moment";

const FabricLoadingCapacityOfStore = () => {
  
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableError, setTableError] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [metaData, setMetaData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);


  // Antd
  const [visit_dateForm] = Form.useForm();

  const { Title } = Typography;

  // // Redux
  // const filterData = useSelector(({ filter }) => filter.filterData);

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const getAllFabricLoadingCapacityOfStore = useCallback(
    async (filterValues) => {
      const payload = {
        page: filterValues?.page || currentPage,
        ...filterValues,
      }

      setLoading(true);
      setTableError(null);

      const query = `${FABRIC_LOADING_CAPACITY_OF_STORES_LIST_ENDPOINT}`;
      const bodyData = {
        ...payload,
      };

      const response = await getData(query, false, bodyData);
      if (response?.status === 200) {
        setLoading(false);
        setMetaData({
          defaultPageSize: response?.data?.data?.per_page,
          current: response?.data?.data?.current_page,
          defaultCurrent: response?.data?.data?.current_page,
          total: response?.data?.data?.total,
        });
        setTableData(response?.data?.data?.data);
      } else {
        setLoading(false);
        setTableError("Could not load this list.");
        message.error("Error getting Fabric Loading Capacity of Store data");
      }
    },
    [currentPage],
  );
  

  // console.log("Line List dekhi", salesContractList);

  // Effects
  useEffect(() => {
    getAllFabricLoadingCapacityOfStore();
  }, [refresh, getAllFabricLoadingCapacityOfStore]);

  const onModalOpen = () => {
    setIsModalOpen(true);
  };

  const onCloseModal = () => {
    visit_dateForm.resetFields();
    setIsModalOpen(false);
    setIsEdit(false);
  };

  const refetch = () => {
    setRefresh(refresh + 1);
  };

  const deleteSelectedvisit_date = async (id) => {
    setLoading(true);
    const response = await deleteData(`${FABRIC_LOADING_CAPACITY_OF_STORES_DELETE_ENDPOINT}/${id}`);

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Fabric Loading Capacity of Store Deleted Successfully");
      refetch();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const editSelectedvisit_date = async (formValues) => {
    setLoading(true);

    const bodyData = {
      hourly_capacity: formValues?.hourly_capacity,
      no_of_loaders: formValues?.no_of_loaders,
    };

    const response = await putData(
      `${FABRIC_LOADING_CAPACITY_OF_STORES_EDIT_ENDPOINT}/${formValues?.id}`,
      bodyData,
    );

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Fabric Loading Capacity of Store Edited Successfully");
      refetch();
      visit_dateForm.resetFields();
      onCloseModal();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const createNewvisit_date = async (formValues) => {
    setLoading(true);

    const bodyData = {
      hourly_capacity: formValues?.hourly_capacity,
      no_of_loaders: formValues?.no_of_loaders,
    };

    const response = await postData(FABRIC_LOADING_CAPACITY_OF_STORES_ADD_ENDPOINT, bodyData);

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Fabric Loading Capacity of Store Created Successfully");
      refetch();
      visit_dateForm.resetFields();
      onCloseModal();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const openModalForEdit = (record) => {
    setIsEdit(true);

    console.log("recordsss", record);

    visit_dateForm.setFieldsValue({
      id: record?.id,
      hourly_capacity: record?.hourly_capacity,
      no_of_loaders: record?.no_of_loaders,

    });
    // Trigger handleSelectChange to populate sam_range_from and sales contract
    setIsModalOpen(true);
  };

  const changePage = (newPage) => {
    setCurrentPage(newPage);
    refetch();
  };

  const tableColumns = [
    {
      title: "Hourly Capacity",
      dataIndex: ["hourly_capacity"],
      key: "hourly_capacity",
    },
    {
      title: "No of Loaders",
      dataIndex: ["no_of_loaders"],
      key: "no_of_loaders",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => {
        return (
          <Dropdown.Button
            overlay={
              <Menu
                items={[
                  {
                    label: (
                      <Popconfirm
                        title="Are you sure you want to delete?"
                        onConfirm={() => {
                          deleteSelectedvisit_date(record?.id);
                        }}
                      >
                        <span>
                          <DeleteTwoTone />
                        </span>
                        <span
                          style={{
                            color: "red",
                            marginLeft: 5,
                          }}
                        >
                          Delete
                        </span>
                      </Popconfirm>
                    ),
                    key: "1",
                    
                  },
                  {
                    label: (
                      <>
                        <span>
                          <EditTwoTone />
                        </span>
                        <span
                          type="button"
                          style={{ marginLeft: 5 }}
                          onClick={() => {
                            openModalForEdit(record);
                          }}
                        >
                          Edit
                        </span>
                      </>
                    ),
                    key: "2",
                    
                  },
                ]}
              />
            }
          ></Dropdown.Button>
        );
      },
    },
  ];

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                refresh={refresh}
                setRefresh={setRefresh}
                handleAddItemOpen={onModalOpen}
                
                addButtonText="Add New"
                showFilter={showFilter}
                setShowFilter={setShowFilter}
              />
            }
            title={<Title level={5}>Fabric Loading Capacity of Store</Title>}
          />
        }
        content={
          <>
            <FilterComponent
              tableData={tableData}
              filterAPI={getAllFabricLoadingCapacityOfStore}
              showFilter={showFilter}
              setShowFilter={setShowFilter}
              filterName="visit_date"
            />

            <div className="table" style={{ marginTop: 10 }}>
              <ListTable
                loading={loading}
                error={tableError}
                onRetry={() => refetch()}
                emptyText="No records to show yet."
                dataSource={tableData}
                columns={tableColumns}
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: metaData?.defaultPageSize,
                  current: metaData?.current,
                  onChange: (newPage) => {
                    changePage(newPage);
                  },
                  defaultCurrent: metaData?.defaultCurrent,
                  total: metaData?.total,
                }}
              />
            </div>
          </>
        }
      />
      <Modal
        open={isModalOpen}
        title={isEdit ? "Edit Fabric Loading Capacity of Store" : "Create Fabric Loading Capacity of Store"}
        onCancel={() => {
          onCloseModal();
        }}
        maskStyle={{ backdropFilter: "blur(4px)" }}
        footer={null}
      >
        <Form
          form={visit_dateForm}
          layout="vertical"
          onFinish={isEdit ? editSelectedvisit_date : createNewvisit_date}
        >
          <Row gutter={6}>
            <Col span={12}>
              <Form.Item name="id" hidden />
              <Form.Item
                name="hourly_capacity"
                placeholder="Hourly Capacity"
                label="Hourly Capacity"
              >
                <InputNumber style={{width:'100%'}} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="no_of_loaders"
                placeholder="No of Loaders"
                label="No of Loaders"
              >
                <InputNumber style={{width:'100%'}} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={6}>
            <Col span={12}>
              <Button
                type="danger"
                style={{ width: "100%" }}
                onClick={() => {
                  onCloseModal();
                }}
              >
                Discard
              </Button>
            </Col>
            <Col span={12}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                loading={loading}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default FabricLoadingCapacityOfStore;
